import { BetCommunicationMessageType, CoreBetGameCommunicationProcessor } from '@pp/core/src/controllers/gameCommunication/processors/CoreBetGameCommunicationProcessor';
import { AcceptanceState } from '@pp/core/src/controllers/gameCommunication/types';
import { betActions } from '@pp/core/src/store/slices/bets/slice';
import { AcceptedBet } from '@pp/core/src/store/slices/bets/types';

import { highflyerStateActions } from '../../../store/slices/highflyerState/slice';

export class GameCommunicationHFBetProcessor extends CoreBetGameCommunicationProcessor {
  delay = 0;
  messageName = 'bet';
  process(message: BetCommunicationMessageType): void {
    super.process(message);
    const betcode = Number(message.betcode);
    const {
      bets: { acceptedBets },
    } = this.store.getState();
    const checkResult = this.gameCheckThatAllBetsAreProcessed(this.store.getState().bets.acceptedBets);
    console.log("acceptedBets", acceptedBets, betcode);
    if (acceptedBets.length > 0) {
      if (acceptedBets.length === 1) {
        this.store.dispatch(highflyerStateActions.setIsSingleBetPlaced(true));
      }
      acceptedBets.forEach(({ betCode, errorCode }) => {
        if (betCode === betcode) {
          if (errorCode === 0) {
            this.store.dispatch(highflyerStateActions.setIsDealingInProgress(betCode));
          }
          if (errorCode === -1) {
            this.store.dispatch(betActions.wipeBet(betCode));
            this.store.dispatch(highflyerStateActions.resetIsBetPlaced(betCode));
          }
        }
      });
    }
    if (checkResult === 'not_accepted' || checkResult === 'rejected') {
      this.store.dispatch(highflyerStateActions.setIsSingleBetPlaced(false));
    }
  }

  private gameCheckThatAllBetsAreProcessed(acceptedBets: AcceptedBet[]): AcceptanceState {
    let rejectedBetsCount = 0;

    for (const bet of acceptedBets) {
      // error code -1 is set for bets that are yet to receive their resolve status
      if (bet.errorCode === -1) {
        return 'unknown';
      } else if (bet.errorCode > 0) {
        rejectedBetsCount++;
      }
    }

    if (rejectedBetsCount === acceptedBets.length) {
      return 'rejected';
    } else if (rejectedBetsCount > 0) {
      return 'not_accepted';
    }

    return 'accepted';
  }
}
